import type { FeatureCollection } from 'geojson';
import { LngLatBounds } from 'maplibre-gl';

export function boundsFromGeoJSON(geojson: FeatureCollection): LngLatBounds {
  const bounds = new LngLatBounds();
  for (const f of geojson.features) {
    if (f.geometry.type === 'Point') {
      bounds.extend(f.geometry.coordinates as [number, number]);
    } else if (f.geometry.type === 'LineString') {
      for (const c of f.geometry.coordinates) bounds.extend(c as [number, number]);
    } else if (f.geometry.type === 'MultiLineString') {
      for (const line of f.geometry.coordinates)
        for (const c of line) bounds.extend(c as [number, number]);
    }
  }
  return bounds;
}
